import {FormBuilder} from '@angular/forms';
import {UsersStore} from '@store/common/users.store';
import {StudiesStore} from '@store/index';
import {ProjectsFilterStore} from '../control-panel/components/projects-tab/project-filter.store';
import {Layer, LayerType} from './layer';
import {GeospatialFilterStore} from '../api/geospatial-filter.store';

export class ProjectLayer extends Layer {
    filtersStore: ProjectsFilterStore;

    constructor(
        public fb: FormBuilder,
        public geospatialFilterStore: GeospatialFilterStore,
        userStore: UsersStore,
        private studiesStore: StudiesStore,
    ) {
        super('Projects Layer', LayerType.PROJECT, fb, geospatialFilterStore);

        this.filtersStore = new ProjectsFilterStore(this.fb, userStore, studiesStore);
    }
}
